import { render, staticRenderFns } from "./ResetNumberingAskForNextNumber.vue?vue&type=template&id=710e9de4"
import script from "./ResetNumberingAskForNextNumber.vue?vue&type=script&lang=ts"
export * from "./ResetNumberingAskForNextNumber.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('710e9de4')) {
      api.createRecord('710e9de4', component.options)
    } else {
      api.reload('710e9de4', component.options)
    }
    module.hot.accept("./ResetNumberingAskForNextNumber.vue?vue&type=template&id=710e9de4", function () {
      api.rerender('710e9de4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/ResetNumberingAskForNextNumber.vue"
export default component.exports